import { defineComponent as _defineComponent } from 'vue'
import {PropType} from "vue";
import VueI18n from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'InformationCard',
  props: {
  headline: {
    required: false,
    type: String as PropType<string | VueI18n.TranslateResult>,
    default: undefined
  },
  text: {
    required: false,
    type: String as PropType<string | VueI18n.TranslateResult>,
    default: undefined
  },
},
  emits: [
  'onClose',
],
  setup(__props, { emit: emits }) {

const props = __props;





const onHandleIconClick = () => {
  emits('onClose')
}


return { __sfc: true,props, emits, onHandleIconClick }
}

})